import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combines class names using clsx (conditional logic) and merges Tailwind
 * classes intelligently with tailwind-merge to avoid duplicate/conflicting
 * utilities.
 *
 * @example
 * cn('px-2 py-1', condition && 'bg-red-500', 'px-4') // -> 'py-1 bg-red-500 px-4'
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
